module.exports = __webpack_public_path__ + "img/btn-surprise-box-spin.png";